import { _ep0, _mw0, command } from "../commandBuilder";
import { TestRenderEmailTemplate$ } from "../schemas/schemas_0";
export class TestRenderEmailTemplateCommand extends command(_ep0, _mw0, "TestRenderEmailTemplate", TestRenderEmailTemplate$) {
}
